export enum HistoryLabel {
  WidgetsDeleted = 'maWidgetsDeleted',
  WidgetsAdded = 'maWidgetsAdded',
  MenuItemRenamed = 'maMenuItemRenamed',
  MenuItemsReordered = 'maMenuItemsReordered',
  RouteUpdated = 'maRouteUpdated',
  PageUriSEOUpdated = 'maPageUriSEOUpdated',
}
